import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-Heatmap',
  templateUrl: './Heatmap.component.html',
  styleUrls: ['./Heatmap.component.css']
})
export class HeatmapComponent implements OnInit {
  @Input() dataH: any;

  width_h: string = "100%";
  height_h: string = "400";
  type_h: string = "heatmap";
  dataFormat_h: string = "json";
  dataSource_h: any ;
  constructor() { }

  ngOnInit() {
this.dataSource_h = this.dataH ;
  }

}
